import { useState, useEffect } from 'react';
import WorkHero from './components/WorkHero';
import WorkGallery from './components/WorkGallery';
import { SchemaOrg, updateMetaTags, updateTitle, updateCanonical } from '../../utils/seo';

export default function OurWorkPage() {
  useEffect(() => {
    updateTitle('Our Work - Recent Projects & Portfolio | Sooner Blacktop');
    updateCanonical('/our-work');
    updateMetaTags({
      description: 'View our recent parking lot striping, sealcoating, and asphalt repair projects across Oklahoma City. Quality workmanship for commercial properties, retail centers, and municipalities.',
      keywords: 'parking lot projects, striping portfolio, sealcoating examples, before and after, Oklahoma City projects',
      'og:title': 'Our Work - Recent Projects & Portfolio | Sooner Blacktop',
      'og:description': 'View our recent parking lot striping, sealcoating, and asphalt repair projects across Oklahoma City.',
      'twitter:title': 'Our Work - Recent Projects & Portfolio | Sooner Blacktop',
      'twitter:description': 'View our recent parking lot striping, sealcoating, and asphalt repair projects across Oklahoma City.',
    });
  }, []);

  const gallerySchema = {
    name: 'Sooner Blacktop Project Gallery',
    description: 'Recent parking lot striping, sealcoating, and asphalt repair projects in Oklahoma City',
    url: 'https://example.com/our-work',
  };

  return (
    <div className="min-h-screen bg-white pt-20">
      <SchemaOrg type="WebPage" data={gallerySchema} />
      <WorkHero />
      <WorkGallery />
    </div>
  );
}
